import { render } from "./credential-count.vue?vue&type=template&id=58527ce9&scoped=true"
import script from "./credential-count.vue?vue&type=script&lang=js"
export * from "./credential-count.vue?vue&type=script&lang=js"

import "./credential-count.vue?vue&type=style&index=0&id=58527ce9&scoped=scoped&lang=less"

import exportComponent from "D:\\project\\BidData\\code\\xyf_web\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-58527ce9"]])

export default __exports__